import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import pricing from "../assets/data/pricing.json";
import { updateBusinessRequest } from "../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../components/loader/Loader";
import { Image } from "react-bootstrap";
import { addToServiceList } from "../redux/actions/ServiceListActions";
import serviceCode from "../assets/data/serviceCode.json";

const banks = [
  { name: "ECOBANK", logo: "/images/bank/ecobank.webp" },
  { name: "BGFI", logo: "/images/bank/bgfi.webp" },
  { name: "BICEC", logo: "/images/bank/bi.webp" },
  { name: "AFRILAND FISRT BANK", logo: "/images/bank/afb.webp" },
  { name: "GOLDEN BANK", logo: "/images/bank/gb.webp" },
  { name: "SCB", logo: "/images/bank/scb.webp" },
  { name: "UBA", logo: "/images/bank/uba.webp" },
  { name: "BANQUE ATLANTIQUE", logo: "/images/bank/atlantique.webp" },
  { name: "CBC", logo: "/images/bank/commercial-bank.webp" },
  { name: "UBC", logo: "/images/bank/ubc.webp" },
];

function Bank() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const { businessCreationRequest } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);

  const handleBoxClick = async (bankName) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        bank: {
          name: bankName,
          amount: pricing.bank,
        },
      })
    );

    if (cart.from === "creation") {
      await dispatch(
        addToServiceList({
          code: serviceCode.bank,
          billing: "lifetime",
        })
      );

      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            bank: bankName,
          },
          handleCallback
        )
      );
    } else {
      navigate("/domiciliation");
    }
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/domiciliation");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleSkipClick = () => {
    navigate("/domiciliation");
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />
      <Loader isLoading={submitting} />

      {/* Title Section */}
      <div
        className="container mt-4 mb-4 text-center"
        style={{ maxWidth: "800px" }}
      >
        <h4 className="text-2xl font-semibold">
          Dans quelle <span style={{ color: "#FF5500" }}>banque</span>{" "}
          envisagez-vous ouvrir le compte de votre {cart?.businessType} ?
        </h4>
      </div>

      {/* Bank Boxes Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <div
          className="bank-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)", // 5 colonnes sur grand écran
            gap: "20px", // Espacement entre les banques
            maxWidth: "800px", // Largeur max pour éviter l'étirement
          }}
        >
          {banks.map((bank, index) => (
            <div
              key={index}
              className="bank-box p-4 rounded-lg d-flex flex-column align-items-center"
              style={{
                border: "2px solid #ddd",
                borderRadius: "8px",
                cursor: "pointer",
                height: "120px",
                transition: "border-color 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.borderColor = "#FF5500")
              }
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#ddd")}
              onClick={() => handleBoxClick(bank.name)}
            >
              <Image
                src={bank.logo}
                alt={bank.name}
                className="img-fluid mb-3"
                style={{
                  height: "100px",
                  width: "100px",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
        </div>

        {/* Style responsive */}
        <style jsx>{`
          @media (max-width: 768px) {
            .bank-grid {
              grid-template-columns: repeat(
                2,
                1fr
              ) !important; /* 1 par ligne sur mobile */
            }
          }
        `}</style>
      </div>

      <div className="container text-center mt-3">
        <span
          onClick={handleSkipClick}
          style={{ color: "#3392FF", cursor: "pointer" }}
        >
          Pas maintenant, peut-être plus tard.
        </span>
      </div>
    </div>
  );
}

export default Bank;
